import Transformer from "@/transformers/transformer";

class ExecutedQuantityTransformer extends Transformer {
  static fetch({ concepts, ...data }) {
    return {
      ...data,
      concepts: (concepts || []).map(
        ({ id, name, quantity_executed: quantityExecuted }) => ({
          id,
          quantityExecuted: +quantityExecuted,
          name,
        })
      ),
    };
  }

  static send({
    concepts,
    workedDays,
    avegareMWorkers,
    avegareOWorkers,
    avegareFWorkers,
    avegareAWorkers,
  }) {
    return {
      real_worked_days: workedDays || 0,
      average_master_workers: avegareMWorkers || 0,
      average_official_workers: avegareOWorkers || 0,
      average_flag_workers: avegareFWorkers || 0,
      average_assistant_workers: avegareAWorkers || 0,
      concepts: concepts.map(({ id, realQuantity }) => ({
        id,
        quantity_executed: realQuantity,
      })),
    };
  }
}

export default ExecutedQuantityTransformer;



// WEBPACK FOOTER //
// ./src/transformers/purchase/executedQuantity.js